module.exports = __webpack_public_path__ + "img/financiero.00113868.svg";